import React, {Component} from "react";
import {Growl} from 'primereact/growl';
import AvailableDetailView from "./AvailableDetailView";
import {AvailableDetailService} from "../../../../service/operation/availableValuesPTM/AvailableDetailService";
import {Column} from "primereact/column";
import {numberWithComma} from "../../../../utils/formatters/Numbers";
import {DataTable} from "primereact/datatable";
import {Builder} from "../../../../utils/lists/ListProcessor";

export default class AvailableLendContainer extends Component {
    /**
     * Constructor de la clase, se inicializan las variables.
     * @param {jmap} props Argumento que trae los valores iniciales de la clase
     */
    constructor(props) {
        super(props);
        this.availableDetailService = new AvailableDetailService();
        this.getDataAvailableDetail = this.getDataAvailableDetail.bind(this);

        this.state = {
            dataAvailableDetail: this.getDataAvailableDetail(''),
            emisoraToSearch: '',
            isLoading: true,
            expanded: false,
        };

        this.rowExpansionTemplate = this.rowExpansionTemplate.bind(this);
        this.expandReduceAll = this.expandReduceAll.bind(this);
        this.onChangeTextFilter = this.onChangeTextFilter.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.searchEmisora = this.searchEmisora.bind(this);
        this.loading = this.loading.bind(this);
    }

    /**
     * Función que setea la variable para que se vea la barra de carga
     */
    loading(option) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: option ? option : false
            });
        }
    }

    /**
     * Función que consulta al back para obtener la información de la pantalla
     * Disponible detalle que se muestra en una tabla.
     * @param emisoraStr Argumento que indica lo que se va a buscar.
     *                  Si viene vacío, se trae toda la información
     * @returns {Promise<void>} Lista que se mostrará en la tabla.
     */
    getDataAvailableDetail(emisoraStr) {
        this.loading(true);
        return this.availableDetailService.getAvailableDetailPTM(emisoraStr)
            .then(resp => {
                let builder = new Builder();
                builder.groupList(resp.payload, 'emision');
                this.setState({
                    dataAvailableDetail: builder.mapObjects,
                    expanded: false,
                    expandedRows: [],
                });
                this.loading(false);
            });
    }

    /**
     * Función que se manda a la vista para que se ejecute cuando se da clic en el
     * botón de buscar, ya que busca el texto que se encuentra en la sección
     * de filtros.
     */
    searchEmisora() {
        this.loading();
        this.getDataAvailableDetail(this.state.emisoraToSearch)
    }

    /**
     * Función que maneja el cambio de texto en el campo de texto de los filtros
     * Coloca el valor en una variable del estado.
     * @param event Contiene el valor y el objeto modificado.
     */
    onChangeTextFilter(event) {
        const {name, value} = event.target;
        this.setState({[name]: value,})
    }

    /**
     * Función que limpia el valor que se encuentra en la caja de texto de los filtros.
     */
    clearFilters() {
        this.setState({emisoraToSearch: ''})
    }

    /**
     * Función que maneja qué fila fue seleccionada para expandirla
     * y mostrar la lista que contiene.
     * @param event Evento que trae la información de la opción expandida.
     */
    handleToggle = (event) => {
        this.setState({
            expandedRows: event.data,
        })
    };

    /**
     * Función que realiza un template de las listas que se contienen en las emisoras
     * Realiza una tabla donde las muestra.
     * @param data Información de la lista contenida en cada renglón principal.
     * @returns {*} Template para cada una de las cuentas
     */
    rowExpansionTemplate(data) {
        const itemsInstitution = data.items;
        return (
            <div className="p-grid p-fluid" style={{padding: '1em'}}>
                <DataTable
                    value={itemsInstitution}
                    selectionMode="single">
                    <Column field="nomCorto" header="Institución" style={{textAlign: 'left'}} sortable={true}/>
                    <Column field="cantidadDisponible" header="Títulos" style={{textAlign: 'right'}}
                            body={this.formatNumberTemplate} sortable={true}/>
                    <Column field="precio24Hrs" header="Precio" style={{textAlign: 'right'}}
                            body={this.formatNumberTemplate} sortable={true}/>
                    <Column field="importeDisponible" header="Importe" style={{textAlign: 'right'}}
                            body={this.formatNumberTemplate} sortable={true}/>
                </DataTable>
            </div>
        );
    }

    formatNumberTemplate(rowData, column) {
        let nDecimals = column['field'] === "precio24Hrs" ? 6 : 2;
        return numberWithComma(rowData[column['field']], "right",
            false, nDecimals, true);
    }

    /**
     * Función que se encarga de contraer y expandir los grupos de
     * emisoras en el dataTable
     */
    expandReduceAll() {
        if (this.state.expanded) {
            this.setState({
                expandedRows: [],
                expanded: false,
            });
        } else {
            this.setState({
                expandedRows: this.state.dataAvailableDetail,
                expanded: true,
            });
        }
    }

    /**
     * Función que realiza el render de la pantalla cuando existe un cambio.
     * En esta se le pasa a la vista lo que necesita para pintarse.
     * @returns {*}
     */
    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        const {dataAvailableDetail, emisoraToSearch, isLoading, expandedRows} = this.state;

        return <AvailableDetailView dataAvailableDetail={dataAvailableDetail}
                                    isLoading={isLoading}
                                    emisoraToSearch={emisoraToSearch}
                                    messagesGrowl={messagesGrowl}
                                    expandedRows={expandedRows}
                                    rowExpansionTemplate={this.rowExpansionTemplate}
                                    expandReduceAll={this.expandReduceAll}
                                    handleToggle={this.handleToggle}
                                    onChangeTextFilter={this.onChangeTextFilter}
                                    clearFilters={this.clearFilters}
                                    searchEmisora={this.searchEmisora}
                                    searchAll={this.getDataAvailableLend}
        />
    }
};